
<!-- <mat-card [formGroup]="paymentForm">
    <mat-card-header>

      <mat-card-subtitle>

      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>

    </mat-card-content>
    <mat-card-actions>
    <div class="" >


      <div class="row">

        <div class="col-lg-6">
          <mat-select name="item" placeholder="Cliamant Type" class="form-control">
            <mat-option *ngFor="let ownershiptype of ownershiptypes" [value]="ownershiptype.id" (click)="selectOwnershipType(ownershiptype,i)">
              {{ownershiptype.OwnershipTypeName}}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-lg-6">

          <input type="text"
          placeholder="Claimant/Beneficiary"
          aria-label="Number"
          matInput
          [matAutocomplete]="auto" #name (keyup)="searchAddressBook(name.value)" >

          <mat-autocomplete autoActiveFirstOption  #auto="matAutocomplete">
            <mat-option *ngFor="let addressbook of addressbooks"
             (click)="selectaddressbook(addressbook)" [value]="addressbook.Name">
              {{addressbook.Name}}
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <mat-select name="item" placeholder="Land Type">
            <mat-option *ngFor="let terrain of terrains" [value]="terrain.id" (click)="selectTerrain(terrain)">
              {{terrain.TerrainName}}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-lg-6">
          <button mat-raised-button class="btn-primary m-2" (click)="addPayment()" [disabled]="(!OwnershipTypeId || !Ownerners) || (!LandType || !TerrianName)"><mat-icon>add</mat-icon> Add new</button>
          <button mat-raised-button class="btn-primary m-2" [disabled]="(paymentForm.invalid || !OwnershipTypeId ) || (!LandType || !TerrianName || !Ownerners)" (click)="onSubmit(paymentForm.value)"><mat-icon>save</mat-icon> Save changes</button>
        </div>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">S/N</th>

            <th scope="col">Item</th>

            <th scope="col">Rate</th>
             <th scope="col">Company Rate</th>
             <th scope="col">Qty</th>
              <th scope="col">UOM</th>
              <th scope="col">Actual Amount</th>
              <th scope="col">Negotiate Amount</th>
              <th scope="col">Remark</th>
              <th scope="col">Del</th>
          </tr>
        </thead>
        <tbody formArrayName="Lessors">
          <tr *ngFor="let lessor of paymentForm.get('Lessors')['controls']; index as i" [formGroupName]="i">
            <th scope="row">{{i + 1}}</th>

          <td>
            <input type="text"

              aria-label="Number"
              matInput
              [matAutocomplete]="auto2" #name2 (keyup)="searchItem(name2.value)" >

              <mat-autocomplete autoActiveFirstOption  #auto2="matAutocomplete">
                <mat-option *ngFor="let item of itemList"
                 (click)="selectItem(item, i)" [value]="item.ItemName">
                  {{item.ItemName}}
                </mat-option>
              </mat-autocomplete>
          </td>



        <td>
        <mat-form-field>
          <input matInput type="number"  formControlName="Rate" (keyup)="calcTotal(i)" >
        </mat-form-field>

      <td>
        <mat-form-field>
          <input matInput formControlName="CompanyApprovedRate" readonly>
        </mat-form-field>

    </td>

    <td>
      <mat-form-field>
        <input matInput type="number" formControlName="Qty"  (keyup)="calcTotal(i)">
      </mat-form-field>
    </td>

        <td>
          <mat-form-field>
            <input matInput formControlName="MeasureName" readonly>
          </mat-form-field>
        </td>

        <td>
          <mat-form-field>
            <input matInput type="number" formControlName="Amount" readonly>
          </mat-form-field>
      </td>

      <td>
        <mat-form-field>
          <input matInput type="number" formControlName="NegotiatedAmount">
        </mat-form-field>
    </td>

    <td>
      <mat-form-field>
        <input matInput formControlName="Remarks">
      </mat-form-field>
  </td>

  <td>
  <button mat-icon-button (click)="deleteLessor(lessor.value, i)"><mat-icon class="text-danger">delete</mat-icon></button>
  </td>
  </tr>
    <tr>
      <td colspan="5"></td>
      <td >Total: </td>

      <td class="text-danger">{{calcTotal().totalAmount.toFixed(2)}}</td>
      <td class="text-danger" colspan="3">{{calcTotal().totalNegotiated.toFixed(2)}}</td>

    </tr>
        </tbody>
      </table>

    </div>
    </mat-card-actions>
  </mat-card>
   -->

   <main class="main_acquisition">


    <div class="other_contents">

      <div class="contents">
        <!-- PAYMENTS PAYMENTS=========================PAYMENTS PAYMENTS=================PAYMENTS PAYMENTS===========PAYMENTS PAYMENTS -->
        <div class="payment_module">
          <div class="form_input">

            <!-- Process payment=========================Process payment===================== -->

            <div class="cost_Surface--form">
              <h2 class="title">Payment</h2>

              <form [formGroup]="paymentForm">

                <div class="input">
                <label for="">Cliamant Type</label>

                  <mat-select name="item" formControlName="OwnershipTypeId" placeholder="Cliamant Type"
                  class="default_input reference-form"
                  >
                    <mat-option *ngFor="let ownershiptype of ownershiptypes" [value]="ownershiptype.id" (click)="selectOwnershipType(ownershiptype)">
                      {{ownershiptype.OwnershipTypeName}}
                    </mat-option>
                  </mat-select>
                </div>
                <div class="input">
                  <label for="">Claimant/Beneficiary</label>
                  <input type="text"
                  placeholder="Search Owner"
                  aria-label="Number"
                  formControlName="ownerName"
                  matInput
                  class="default_input reference-form"
                  [matAutocomplete]="auto" #name (keyup)="searchAddressBook(name.value)" >

                  <mat-autocomplete autoActiveFirstOption  #auto="matAutocomplete">
                    <mat-option *ngFor="let addressbook of addressbooks"
                     (click)="selectaddressbook(addressbook)" [value]="addressbook.Name">
                      <span>{{addressbook.Name}}</span>
                    </mat-option>
                  </mat-autocomplete>
                </div>

                <div class="input" *ngIf="lessorType !== 'lessorInfo'">
                  <label for="">
                    <span *ngIf="PaymentType !== 'Incident'; else DisplayIncident">Land Type</span>
                    <ng-template #DisplayIncident>Asset Type</ng-template>

                    <span class="text-danger">*</span></label>
                  <mat-select name="item" [placeholder]=" PaymentType !== 'Incident' ? 'Land Type' : 'Asset Type'"
                  formControlName="LandType"
                  class="default_input reference-form"
                  >
                    <mat-option *ngFor="let terrain of terrains" [value]="terrain.id" (click)="selectTerrain(terrain)">
                      {{terrain.TerrainName}}
                    </mat-option>
                  </mat-select>
                </div>
  <hr />
                <div class="input">
                  <label for="">Item</label>
                  <input type="text"
                  aria-label="Number"
                  class="default_input reference-form"
                  matInput
                  formControlName="ItemName"
                  [matAutocomplete]="auto2" #name2 (click)="onSearchDamageList()" >
                  <mat-autocomplete autoActiveFirstOption  #auto2="matAutocomplete">
                    <mat-option *ngFor="let item of itemList"
                     (click)="selectItem(item)" [value]="item.ItemName">
                      {{item.ItemName}}
                    </mat-option>
                  </mat-autocomplete>
                </div>

                <div class="input">
                  <label for="">Rate <span class="text-danger">*</span></label>
                 <input  type="number" class="default_input reference-form" formControlName="Rate">
                </div>

                <div class="input">
                  <label for="">Company Rate <span class="text-danger">*</span></label>
                  <input type="number" class="default_input reference-form" formControlName="CompanyApprovedRate"/>
                </div>

                  <div class="input">
                  <label for="">Quantity <span class="text-danger">*</span></label>
                  <input type="number" class="default_input reference-form" formControlName="Qty"  (keyup)="calcAmount()"/>
                </div>

                <div class="input">
                  <label for="">Unit of Measure <span class="text-danger">*</span></label>
                  <input type="text" class="default_input reference-form" formControlName="MeasureName"/>
                </div>


                <div class="input">
                  <label for="">Amount <span class="text-danger">*</span></label>
                  <input type="number" class="default_input reference-form" readonly formControlName="Amount"/>
                </div>


                <div class="input">
                  <label for="">Negotiated Amount <span class="text-danger">*</span></label>
                  <input type="number" class="default_input reference-form"  formControlName="NegotiatedAmount"/>
                </div>

                <div class="input">
                  <label for="">Remark</label>
                  <input type="text" class="default_input reference-form" formControlName="Remarks" />
                </div>
                <!-- <pre>{{paymentForm.value | json}}</pre> -->
              </form>
            </div>
            <div class="btn_holder">
              <button class="default_primary-button" (click)="savePayment(paymentForm.value)">Save Payment</button>
            </div>
          </div>
          <!-- right side=========================================right side -->
          <div class="soln">
            <div class="tab_top">
              <div class="summary">
                <p class="total_summary">
                  <span>Total:</span>
                  <span class="amount" style="color: rgb(199, 38, 38);">{{calcTotal().totalAmount | number:'1.2'}} </span>
                </p>
                <p class="negotiated_summary">
                  <span>Negotiated Amt:</span>
                  <span class="amount" style="color: rgb(199, 38, 38);"> {{calcTotal().totalNegotiated | number:'1.2'}} </span>
                </p>
                <p class="difference_summary">
                  <span>Difference:</span>
                  <span class="amount" style="color: rgb(199, 38, 38);"> {{(calcTotal().totalAmount - calcTotal().totalNegotiated) | number:'1.2'}}</span>
                </p>
              </div>

              <div class="tab_buttons-new" *ngIf="PaymentType !== 'Incident'">

                <button class="active" (click)="onLessorDialog('lessorInfo')">Lessors</button>
                <button (click)="onLessorDialog('representative')">Representatives</button>
                <button (click)="onLessorDialog('stakeholder')">Stakeholders</button>

            </div>

            </div>

            <div class="payment_tab">


<div class="toggle_payment_view">
  <mat-button-toggle-group
name="fontStyle"
aria-label="Font Style"
color="accent"
class="m-3"

>
<mat-button-toggle value="list" color="accent" (click)="onList()"
  ><mat-icon class="example-tab-icon"
    >list</mat-icon
  ></mat-button-toggle
>
<mat-button-toggle value="grid" (click)="onGrid()"
  ><mat-icon class="example-tab-icon"
    >view_module</mat-icon
  ></mat-button-toggle
>
</mat-button-toggle-group>
</div>

              <!-- PROCESS PAYMENT========================PROCESS PAYMENT=====================PROCESS PAYMENT========= -->
    <ng-container *ngIf="gridView">
              <div class="tab_content">
                <div class="pay_content">
                    <div class="entry"  *ngFor="let lessor of filteredPayment; index as i" (click)="selectPayment(lessor)">
                      <p class="top_entry--info"><span>.{{i + 1}}</span></p>
                      <p class="info"><span>Item: </span>{{lessor.ItemName}}</p>
                      <p class="info"><span>Rate: </span> {{lessor.Rate}}</p>
                      <p class="info"><span>Company Rate: </span> {{lessor.CompanyApprovedRate}}</p>
                      <p class="info"><span>Quantity: </span>{{lessor.Qty}}</p>
                      <p class="info"><span>Actual Amt: </span>{{lessor.Amount | number:'1.2'}}</p>
                      <p class="info"><span>Negotiated Amt: </span>{{lessor.NegotiatedAmount | number:'1.2'}}</p>
                      <p class="info"><span>Unit Of Measure: </span>{{lessor.MeasureName}}</p>
                      <p class="info"><span>Payment Status: </span>{{lessor.PaymentStatus}}</p>
                      <p class="info"><span>Remark: </span>{{lessor.Remarks}}</p>
                      <p class="info"><span>Approval Remark: </span>{{lessor.ApprovalRemarks}}</p>
                      <p class="info"><span>Status: </span>{{lessor.PaymentStatus}}</p>
                      <button mat-icon-button (click)="deleteLessor(lessor);" class="text-danger" [disabled]="lessor.PaymentStatus.includes('PAID')"> <i class="ti-trash"></i></button>
                  </div>
                </div>
              </div>

            </ng-container>

              <div class="card mt-3 " *ngIf="listView">
                <div class="table-responsive">
                <table class="table table-hover" >
                  <thead>
                    <tr>
                      <th scope="col">S/N</th>
                      <th scope="col">Item</th>
                      <th scope="col">Rate</th>
                      <th scope="col">Company Rate</th>
                      <th scope="col">Quantity</th>
                      <th scope="col">Actual Amt</th>
                      <th scope="col">Negotiated Amt</th>
                      <th scope="col">Unit Of Measure</th>
                      <th scope="col">Payment Status</th>
                      <th scope="col">Remark</th>
                      <th scope="col">Approval Remark</th>
                      <th scope="col">Status</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody >
                    <tr  *ngFor="let lessor of filteredPayment; index as i" (click)="selectPayment(lessor)"
                    style="cursor: pointer;"
                    >
                      <th scope="row">{{i + 1}}</th>
                      <td>{{lessor.ItemName}}</td>
                      <td>{{lessor.Rate}}</td>
                      <td> {{lessor.CompanyApprovedRate}}</td>
                      <td>{{lessor.Qty}}</td>
                      <td>{{lessor.Amount | number:'1.2'}}</td>
                      <td>{{lessor.NegotiatedAmount | number:'1.2'}}</td>
                      <td>{{lessor.MeasureName}}</td>
                      <td>{{lessor.PaymentStatus}}</td>
                      <td>{{lessor.Remarks}}</td>
                      <td>{{lessor.ApprovalRemarks}}</td>
                      <td>{{lessor.PaymentStatus}}</td>

                      <td (click)="$event.stopImmediatePropagation()" style="cursor: pointer;">
                        <i class="ti-trash" [hidden]="lessor.PaymentStatus.includes('PAID')" (click)="deleteLessor(lessor);"></i>
                       </td>
                    </tr>

                  </tbody>
                </table>
              </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- search popup=========================================search popup -->


    <div class="submit">
      <button class="default_primary-button" (click)="onSubmit(filteredPayment)">Submit Payment</button>
    </div>
  </main>
